import { render } from "./AboutView.vue?vue&type=template&id=2ebee4c7&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=2ebee4c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebee4c7"]])

export default __exports__